import React, {useState, useEffect, useRef} from 'react';
import {MarketingText} from 'app/utilities/highlightText';
import BackgroundVideo from './BackgroundVideo';
import TeaserTexts from './TeaserTexts';
import classNames from 'classnames';
import {ImageProps} from 'app/utilities/ImageProps';
import {BooleanProperty, LinkProperty, NumberProperty, StringProperty} from '@episerver/spa-core/Property';

type stickyHeaderProps = {
  videoUrl: string;
  fallbackImage: ImageProps;
  texts: MarketingText[];
  isTvContent: boolean;
  titleHeadlineTag?: NumberProperty;
  isShowHeaderButton?:BooleanProperty;
  headerButtonLink?:StringProperty;
  context?: any;
  blockButton?: any;
};

const StickyHeader = ({blockButton,videoUrl, fallbackImage, texts, isTvContent, titleHeadlineTag,isShowHeaderButton,headerButtonLink,context}: stickyHeaderProps) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [isSticky, setIsSticky] = useState(true);
  const [top, setTop] = useState<Number>(null);

  useEffect(() => {
    if (anchorRef == null) return;

    const onScroll = () => {
      const windowScroll = window.scrollY || window.pageYOffset;
      const achorPosition = anchorRef.current.offsetTop;
      setIsSticky(windowScroll + window.innerHeight < achorPosition);
    };
    const onResize = () => {
      setTop(anchorRef.current.offsetTop - window.innerHeight);
      onScroll();
    };

    // onResize();

    // window.addEventListener('scroll', onScroll);
    // window.addEventListener('resize', onResize);

    return () => {
      // window.removeEventListener('scroll', onScroll);
      // window.removeEventListener('resize', onResize);
    };
  }, [anchorRef]);

  return (
    <>
      <div className={classNames('StickyHeader', {sticky: isSticky})} style={{top: !isSticky ? `${top ?? 0}px` : null}}>
        <BackgroundVideo videoUrl={videoUrl} fallbackImageProps={fallbackImage} />
      </div>
      <TeaserTexts blockButton={blockButton} titleHeadlineTag={titleHeadlineTag} texts={texts} isTvContent={isTvContent} isShowHeaderButton={isShowHeaderButton} headerButtonLink={headerButtonLink} context={context} />
      <div ref={anchorRef} className='StickyHeader__anchor bottom-anchor'></div>
    </>
  );
};

export default StickyHeader;
